var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atlas-w-full atlas-h-full",attrs:{"data-testid":"site-utility-report-download-container"}},[_c('DownloadUtilityReport')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }